var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"traffic-light"},_vm._l((_vm.colorList),function(color){return _c('span',{key:color,staticClass:"traffic-light__circle",class:[
      ("color--" + color),
      (color === _vm.activeColor) && 'active'
    ]})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }